__turbopack_context__.v({
  "active": "PaginationNavigation-module__5sE4eG__active",
  "container": "PaginationNavigation-module__5sE4eG__container",
  "navButton": "PaginationNavigation-module__5sE4eG__navButton",
  "navButtonIcon": "PaginationNavigation-module__5sE4eG__navButtonIcon",
  "pageButton": "PaginationNavigation-module__5sE4eG__pageButton",
});
